import { render, staticRenderFns } from "./message-tip.vue?vue&type=template&id=a761559e&scoped=true"
import script from "./message-tip.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-tip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-tip.vue?vue&type=style&index=0&id=a761559e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a761559e",
  null
  
)

export default component.exports